import type { ExperimentsBag } from '@wix/wix-experiments'

export const getCMSWebAppDashboardSlug = (experiments: ExperimentsBag) => {
  return experiments['specs.wixCode.CMSWebDevCenterApp'] === 'true'
    ? 'wix-cms'
    : 'database'
}
